import PropTypes from "prop-types"
import { path } from "ramda"
import React from "react"

export default function withFormField(WrappedComponent) {
  class Field extends React.Component {
    static propTypes = {}

    static defaultProps = {
      disabled: false,
      readOnly: false
    }

    static contextTypes = {
      form: PropTypes.object,
      fields: PropTypes.object
    }

    constructor(props, context) {
      super(props, context)
      this.myRef = React.createRef()
      const { fieldPath } = props
      this._fieldPath = fieldPath
      this.register()
    }

    register() {
      const {
        context,
        _fieldPath
      } = this
      const {
        form
      } = context
      form && form.registerField && form.registerField({ fieldProps: { fieldPath: _fieldPath } })
    }

    unregister() {
      const {
        context,
        _fieldPath
      } = this
      const {
        form
      } = context
      form.unregisterField({ fieldProps: { fieldPath: _fieldPath } })
    }

    handleFocus = (event) => {
    }
    handleChange = (args) => {
    }
    handleBlur = (event) => {
    }

    scrollToSelf = () => {
      window.scroll({
        top: this.myRef.current.offsetTop - 70,
        left: 0,
        behavior: "smooth"
      })
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
      let nextContextProps = path(this._fieldPath, nextContext.fields)
      if (!nextContextProps) return

      if (nextContextProps?.isFirstError) {
        this.scrollToSelf()
        nextContextProps.isFirstError = false
      }

      this.contextProps = nextContextProps
    }

    componentWillUnmount() {
      this.unregister()
    }

    render() {
      const { props, contextProps } = this
      return <WrappedComponent ref={this.myRef} {...props} fieldState={contextProps} handleFieldFocus={this.handleFocus}
                               handleFieldChange={this.handleChange} handleFieldBlur={this.handleBlur} />
    }
  }

  return Field
}
